<template>
  <div class="warning-box has-border mb-50 p-50" v-if="warnings.length">
    <div class="warning-title">
      <strong>
        {{ title }} -
        <span class="warning-box-count small-text">{{ warnings.length }} {{ warnings.length > 1 ? 'warnings' : 'warning' }}</span>
      </strong>
    </div>

    <div class="warning-box-instruction py-50">
      <p class="small-text" v-if="hint">
        <icon-default icon="help" size="is-small"></icon-default>
        <strong class="ml-25">{{ hint }}</strong>
      </p>
    </div>

    <div v-for="(warning, index) in warnings" :key="index" class="has-border-bottom p-50 pb-25 m-25">
      <p class="small-text">- {{ warning }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ImportValidationModal',
  props: {
    warnings: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    hint: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
@import "../../../styles/variables/variables";

.warning-box-instruction {
  line-height: 1.3;

  .small-text {
    display: flex;
    align-items: center;
  }
}

.warning-box-count { color: $text-muted; }
</style>
